import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Brain } from 'lucide-react';
import OutcomeRecords from '../components/letterIntel/OutcomeRecords';
import WinRates from '../components/letterIntel/WinRates';
import Variations from '../components/letterIntel/Variations';

const TABS = [['results', 'Log results'], ['rates', 'Win rates'], ['variations', 'New variations']];

export default function LetterIntelligencePage() {
  const [tab, setTab] = useState('results');
  return (
    <div className="min-h-screen bg-zinc-950 text-white p-4 md:p-6" data-testid="letter-intel-page">
      <div className="max-w-4xl mx-auto space-y-4">
        <Link to="/ftc-builder" className="text-sm text-zinc-400 hover:text-white flex items-center gap-1" data-testid="letter-intel-back"><ArrowLeft className="w-4 h-4" />FTC Report Builder</Link>
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2"><Brain className="w-6 h-6 text-violet-400" />Letter Intelligence</h1>
          <p className="text-xs text-zinc-500 mt-1">Log what the bureaus did with each letter. The AI learns which strategies get deletions and writes better variations for you to approve.</p>
        </div>
        <div className="flex gap-2">
          {TABS.map(([k, l]) => (
            <button key={k} type="button" onClick={() => setTab(k)} data-testid={`letter-intel-tab-${k}`}
              className={`rounded-full border px-3 py-1.5 text-xs font-semibold ${tab === k ? 'bg-amber-500 border-amber-500 text-black' : 'border-zinc-700 text-zinc-400 hover:text-white'}`}>{l}</button>
          ))}
        </div>
        {tab === 'results' && <OutcomeRecords />}
        {tab === 'rates' && <WinRates />}
        {tab === 'variations' && <Variations />}
      </div>
    </div>
  );
}
